import { motion } from "framer-motion";
import { Info, Users } from "lucide-react";

function Banner({ testId, icon, children }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      data-testid={testId}
      className="mt-6 flex items-start gap-3 rounded-2xl border border-border bg-secondary/50 p-4"
    >
      {icon}
      <p className="text-sm text-muted-foreground">{children}</p>
    </motion.div>
  );
}

export function ItineraryBanners({ plan, shared }) {
  const canVote = shared && (plan.options?.dinner?.length > 1 || plan.options?.drinks?.length > 1);
  return (
    <>
      {!plan.event_found && (
        <Banner testId="no-event-banner" icon={<Info size={18} className="mt-0.5 shrink-0 neon-cyan" />}>
          No live events on Ticketmaster for {plan.city} on this date, so we built a
          <span className="font-semibold text-foreground"> two-stop dinner &amp; drinks </span>
          plan instead. Try a different date to add a live show.
        </Banner>
      )}
      {canVote && (
        <Banner testId="vote-intro" icon={<Users size={18} className="mt-0.5 shrink-0 neon-magenta" />}>
          <span className="font-semibold text-foreground">Your crew can vote.</span> Pick your favorite dinner and
          drinks option below — everyone with this link sees the live tally.
        </Banner>
      )}
    </>
  );
}
